import { Component, OnInit, signal } from '@angular/core';
import { UserItem } from '../services/storage-types';
import { StorageRouterService } from '../services/storage-router.service';

@Component({
    selector: 'app-debug-makers',
    templateUrl: './debug-makers.component.html',
    standalone: false
})
export class DebugMakersComponent implements OnInit {

    users = signal<UserItem[]>([]);
    loading = signal(false);
    error = signal<string | null>(null);

    constructor(
        private router: StorageRouterService
    ) {}

    ngOnInit(): void {
        this.load();
    }

    async load(): Promise<void> {
        this.loading.set(true);
        this.error.set(null);
        try {
            const result = await this.router.getUsers();
            this.users.set(result);
        } catch (err: any) {
            this.error.set(err?.message ?? String(err));
            this.users.set([]);
        } finally {
            this.loading.set(false);
        }
    }
}
